import Blank from "@/layouts/blank.vue"

import UserManagementList from "@/pages/admin/user-management/UserManagementList.vue";
import UserManagementAdd from "@/pages/admin/user-management/UserManagementAdd.vue";
import UserManagementEdit from "@/pages/admin/user-management/UserManagementEdit.vue";
import HandlerUserAdd from "@/pages/admin/user-management/HandlerUserAdd.vue";
import HandlerUserEdit from "@/pages/admin/user-management/HandlerUserEdit.vue";

const userManagementRoutes = [
  {
    path: "user-management",
    name: "app-admin-user-management",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/user-management/list",
      },
      {
        path: "list",
        name: "app-admin-user-management-list",
        component: UserManagementList,
      },
      {
        path: "add",
        name: "app-admin-user-management-add",
        component: UserManagementAdd,
      },
      {
        path: "edit",
        name: "app-admin-user-management-edit",
        component: Blank,
        children: [
          {
            path: "/",
            redirect: "/app/admin/user-management/list",
          },
          {
            path: ":id",
            name: "app-admin-user-management-edit-id",
            component: UserManagementEdit,
          }
        ]
      },
      {
        path: "handler/add",
        name: "app-admin-handler-user-add",
        component: HandlerUserAdd,
      },
      {
        path: "handler/edit/:id",
        name: "app-admin-handler-user-edit",
        component: HandlerUserEdit,
      },
    ]
  },
]

export default userManagementRoutes